export enum GapLogType {
  OFFICE_COMMENT = "OCO",
  OFFICE_CALL = "OCA",
  PATIENT_COMMENT = "PCO",
  PATIENT_ACKNOWLEDGED_SMS_NOTIFICATION = "PAS",
  PROVIDER_COMMENT = "PRC",
}
export enum MessageType {
  ANY = "",
  VOICE = "VOICE",
  AI_VOICE = "AI_VOICE",
  SMS = "SMS",
  SMS_EMAIL = "SMS_EMAIL",
  EMAIL ="EMAIL"

}
export enum GapStatus {
  NEW = "PEN",
  WORKING = "WRK",
  CLOSED = "CLD",
}
export enum GapSubStatus {
  COMPLETED = "CPT",
}
export enum PatientLogType {
  OFFICE_COMMENT = "OCO",
}
export enum GapField {
  // GAP
  GAP_ID = "GAP_ID",
  GAP_CAMPAIGN = "GAP_CAMPAIGN",
  GAP_PROVIDER = "GAP_PROVIDER",
  GAP_INSURER = "GAP_INSURER",
  GAP_DESCRIPTION = "GAP_DESCRIPTION",
  GAP_MEASURE_TYPE = "GAP_MEASURE_TYPE",
  GAP_MEASURE = "GAP_MEASURE",
  GAP_REF_DATE = "GAP_REF_DATE",
  GAP_ADMISSION_DATE = "GAP_ADMISSION_DATE",
  GAP_ADMISSION_DIAGNOSIS = "GAP_ADMISSION_DIAGNOSIS",
  GAP_ADMISSION_PROVIDER = "GAP_ADMISSION_PROVIDER",
  GAP_TEST_DATE = "GAP_TEST_DATE",
  GAP_TEST_RESULT = "GAP_TEST_RESULT",
  GAP_DISCHARGE_DIAGNOSIS = "GAP_DISCHARGE_DIAGNOSIS",
  GAP_FACILITY = "GAP_FACILITY",
  GAP_PHARMACY = "GAP_PHARMACY",
  GAP_MEDICATION = "GAP_MEDICATION",
  GAP_PRIORITY = "GAP_PRIORITY",
  GAP_STATUS = "GAP_STATUS",
  GAP_SUB_STATUS = "GAP_SUB_STATUS",
  GAP_CLOSE_REASON = "GAP_CLOSE_REASON",
  GAP_CLOSE_SUB_REASON = "GAP_CLOSE_SUB_REASON",
  GAP_CLOSE_DATE = "GAP_CLOSE_DATE",
  GAP_REF_ID = "GAP_REF_ID",
  // PATIENT
  PATIENT_ID = "PATIENT_ID",
  PATIENT_FIRST_NAME = "PATIENT_FIRST_NAME",
  PATIENT_LAST_NAME = "PATIENT_LAST_NAME",
  PATIENT_LAST_NAME_2 = "PATIENT_LAST_NAME_2",
  PATIENT_FULL_NAME = "PATIENT_FULL_NAME",
  PATIENT_BIRTHDATE = "PATIENT_BIRTHDATE",
  PATIENT_GENDER = "PATIENT_GENDER",
  PATIENT_ADDRESS_LINE_1 = "PATIENT_ADDRESS_LINE_1",
  PATIENT_ADDRESS_LINE_2 = "PATIENT_ADDRESS_LINE_2",
  PATIENT_CITY = "PATIENT_CITY",
  PATIENT_STATE = "PATIENT_STATE",
  PATIENT_ZIP = "PATIENT_ZIP",
  PATIENT_COUNTRY = "PATIENT_COUNTRY",
  PATIENT_FULL_ADDRESS = "PATIENT_FULL_ADDRESS",
  PATIENT_INSURER = "PATIENT_INSURER",
  PATIENT_MEMBER_ID = "PATIENT_MEMBER_ID",
  PATIENT_PCP_NAME = "PATIENT_PCP_NAME",
  PATIENT_CONTACT_NAME = "PATIENT_CONTACT_NAME",
  PATIENT_HOME_PHONE = "PATIENT_HOME_PHONE",
  PATIENT_MOBILE_PHONE = "PATIENT_MOBILE_PHONE",
  PATIENT_OTHER_PHONE = "PATIENT_OTHER_PHONE",
  PATIENT_OTHER_PHONE_2 = "PATIENT_OTHER_PHONE_2",
  PATIENT_EMAIL = "PATIENT_EMAIL",
  PATIENT_LANG = "PATIENT_LANG",
  PATIENT_EMR_ID = "PATIENT_EMR_ID",
  //
  USER_LONG_NAME = "USER_LONG_NAME"
  //
}
// SCHEDULE
export enum ScheduleView {
  Calendar,
  Group,
  List,
}
export enum ScheduleType {
  REGULAR = "APT",
  SERVICE = "SRV",
  DELIVERY = "DLV",
  READY_RESPONDERS = "RRS",
  REMINDER = "RMD",
}
export enum ScheduleSession {
  MORNING = "MN",
  NOON = "NN",
  AFTERNOON = "AN",
  NIGHT = "NT",
  ANY_TIME = "XX",
}
export enum ScheduleLogType {
  OFFICE_COMMENT = "OCO",
  PATIENT_COMMENT = "PCO",
  DRIVER_COMMENT = "DRC",
  OFFICE_TO_PATIENT_COMMENT = "OPM",
}
export enum SchedulePreReqType {
  FILE = "BIN",
  INFO = "INF",
  PICTURE = "PIC",
  FORM = "FRM",
}
// CASES
export enum CaseLogType {
  OFFICE_COMMENT = "OCO",
  PATIENT_COMMENT = "PCO",
  PATIENT_ACKNOWLEDGED_SMS_NOTIFICATION = "PAS",
  MEDICATION_NOTE = "MDN",
  TASK_COMMENT = "TKC",
  CASE_MANAGER_COMMENT = "CMC",
}
export enum CaseField {
  // CASE
  CASE_ID = "CASE_ID",
  CASE_TYPE = "CASE_TYPE",
  CASE_TRIGGER = "CASE_TRIGGER",
  CASE_REF_SOURCE = "CASE_REF_SOURCE",
  CASE_REF_DATE = "CASE_REF_DATE",
  CASE_RISK_LEVEL = "CASE_RISK_LEVEL",
  CASE_ACTIVITY = "CASE_ACTIVITY",
  CASE_MEDICATION = "CASE_MEDICATION",
  CASE_STATUS = "CASE_STATUS",
  CASE_CLOSE_REASON = "CASE_CLOSE_REASON",
  CASE_OWNER = "CASE_OWNER",
  // PATIENT
  PATIENT_ID = "PATIENT_ID",
  PATIENT_FIRST_NAME = "PATIENT_FIRST_NAME",
  PATIENT_LAST_NAME = "PATIENT_LAST_NAME",
  PATIENT_LAST_NAME_2 = "PATIENT_LAST_NAME_2",
  PATIENT_FULL_NAME = "PATIENT_FULL_NAME",
  PATIENT_BIRTHDATE = "PATIENT_BIRTHDATE",
  PATIENT_GENDER = "PATIENT_GENDER",
  PATIENT_ADDRESS_LINE_1 = "PATIENT_ADDRESS_LINE_1",
  PATIENT_ADDRESS_LINE_2 = "PATIENT_ADDRESS_LINE_2",
  PATIENT_CITY = "PATIENT_CITY",
  PATIENT_STATE = "PATIENT_STATE",
  PATIENT_ZIP = "PATIENT_ZIP",
  PATIENT_COUNTRY = "PATIENT_COUNTRY",
  PATIENT_FULL_ADDRESS = "PATIENT_FULL_ADDRESS",
  PATIENT_INSURER = "PATIENT_INSURER",
  PATIENT_MEMBER_ID = "PATIENT_MEMBER_ID",
  PATIENT_PCP_NAME = "PATIENT_PCP_NAME",
  PATIENT_CONTACT_NAME = "PATIENT_CONTACT_NAME",
  PATIENT_HOME_PHONE = "PATIENT_HOME_PHONE",
  PATIENT_MOBILE_PHONE = "PATIENT_MOBILE_PHONE",
  PATIENT_OTHER_PHONE = "PATIENT_OTHER_PHONE",
  PATIENT_OTHER_PHONE_2 = "PATIENT_OTHER_PHONE_2",
  PATIENT_EMAIL = "PATIENT_EMAIL",
  PATIENT_LANG = "PATIENT_LANG",
  PATIENT_EMR_ID = "PATIENT_EMR_ID",
  //
}
// TASKS
export enum CaseTaskStatus {
  CLOSED = "CLD",
}
// FORMS
export enum FormQuestionType {
  TEXT = "TXT",
  NUMBER = "NUM",
  NUMBER_RANGE = "NRG",
  DATE = "DTE",
  TIME = "TME",
  DATE_TIME = "DTT",
  DATE_RANGE = "DRG",
  BIRTHDATE = "DOB",
  SINGLE_CHOICE = "SGC",
  MULTIPLE_CHOICE = "MTC",
  EDITOR = "EDT",
}
// PROVIDER
export enum ProviderLogType {
  OFFICE_COMMENT = "OCO",
}
// CALLS
export enum CallLogType {
  OFFICE_COMMENT = "OCO",
  OFFICE_TO_CALLER_MESSAGE = "OCM",
  CALLER_TO_OFFICE_MESSAGE = "COM",
  CALLER_LOCATION = "LOC",
  SECURE_CHAT_PHOTO = "SCP",
  SECURE_CHAT_VOICE = "SCV",
  SECURE_CHAT_FILE = "SCF",
  SECURE_CHAT_TTS = "SCS",
  SECURE_CHAT_RECORDING = "SCR",
  ERROR = "ERR",
}
export enum FlowActionType {
  SPEECH = "SPEECH",
  RECORDING = "RECORDING",
  LANGUAGE = "LANGUAGE",
  CALL_TRANSFER = "CALL_TRANSFER",
  FLOW_TRANSFER = "FLOW_TRANSFER",
  FLOW_RESET = "FLOW_RESET",
  VOICEMAIL = "VOICEMAIL",
  SMS = "SMS",
  EMAIL = "EMAIL",
  LOG = "LOG",
  SECURE_CHAT = "SECURE_CHAT",
}
export enum FlowNotificationType {
  CALL = "CALL",
  SMS = "SMS",
  VOICEMAIL = "VOICEMAIL",
  SECURE_CHAT = "SECURE_CHAT",
}
export enum DateTimeSpan {
  TODAY = "TODAY",
  TOMORROW ="TOMORROW",
  WEEK = "WEEK",
  LAST7 = "LAST7",
  MONTH = "MONTH",
}
export enum TemplateMessageType {
  TEXT = "TEXT",
  SPEECH = "SPEECH",
  RECORDING = "RECORDING",
}
//
